<template>
  <div>
    <!-- 标题及按钮 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <div class="page-title-32">文件流转记录</div>
      </mtd-col>
    </mtd-row>
    <!-- 数据来源检索 -->
    <mtd-row style="margin-top: 12px;">
      <mtd-col :span="24" class="policy-search-block">
        <mtd-form inline :label-width="74">
          <mtd-row :gutter="16">
            <mtd-col :span="8" style="padding-left: 0;">
              <mtd-form-item label="MISID:">
                <mtd-select v-model="query_params.otherMisId" placeholder="请输入用户MISID" :filterable="true" clearable
                            style="width: 100%" :remote="true" :remote-method="searchPerson" :debounce="500"
                            key="search_misid">
                  <mtd-option v-for="item in person_groups" :key="item.name + '/' + item.mis"
                              :label="item.name + '/' + item.mis" :value="item.mis"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8">
              <mtd-form-item label="时间分区:">
                <mtd-date-picker type="date" v-model="query_params.startDt" placeholder="请选择时间分区" disabled
                                 value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: calc(50% - 12px)"
                                 class="disabled-picker-block"/>
                <mtd-icon name='minus' style="width: 24px;text-align: center;"></mtd-icon>
                <mtd-date-picker type="date" v-model="query_params.endDt" placeholder="请选择时间分区"
                                 value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: calc(50% - 12px)"
                                 @change="build_start_and_query_dt"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" style="padding-right: 0;">
              <mtd-form-item label="数据来源:">
                <mtd-select v-model="query_params.dataSource" style="width: 100%" @change="build_start_and_query_dt">
                  <mtd-option label="学城" value="km"/>
                  <mtd-option label="大象" value="xm"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" style="padding-left: 0;">
              <mtd-form-item label="文件名称:" style="margin-bottom: 0;">
                <mtd-input type="text" style="width: 100%;" placeholder="请输入文件名称"
                           v-model="query_params.fileName" :clearable="true"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" :offset="8" style="padding-right: 0; text-align: right;">
              <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">重置</mtd-button>
              <mtd-button ghost type="primary" style="width: 80px;" @click="list_user_file">搜索</mtd-button>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!-- 文件流转记录 -->
    <mtd-table :data="alarm_list" size="small" style="margin-top: 12px;">
      <mtd-table-column prop="filename" label="文档名称" show-overflow-tooltip width="400">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
          <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="secretLevel" label="密级"/>
      <mtd-table-column prop="viewUserCnt" label="数据来源">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">大象</span>
          <span v-if="scope.row.dataSource === 'km'">学城</span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="ext1" label="MISID"/>
      <mtd-table-column prop="viewUserCnt" label="查看人数">
        <template slot-scope="scope">
          {{ scope.row.viewUserCnt }}人
        </template>
      </mtd-table-column>
      <mtd-table-column prop="transferUserCnt" label="转发人数">
        <template slot-scope="scope">
          {{ scope.row.transferUserCnt }}人
        </template>
      </mtd-table-column>
      <mtd-table-column prop="downloadUserCnt" label="下载人数">
        <template slot-scope="scope">
          {{ scope.row.downloadUserCnt }}人
        </template>
      </mtd-table-column>
      <mtd-table-column prop="outputUserCnt" label="外发人数">
        <template slot-scope="scope">
          {{ scope.row.outputUserCnt }}人
        </template>
      </mtd-table-column>
      <mtd-table-column label="操作" width="90">
        <template slot-scope="scope">
          <mtd-button type="text" size="small" @click="show_detail(scope.row.id, scope.row.filename)"
                      style="color: #0a70f5;padding-left: 0">
            查看详情
          </mtd-button>
        </template>
      </mtd-table-column>
    </mtd-table>
    <div style="text-align: right;margin-top: 12px;">
      <mtd-pagination size="small" show-size-changer show-total :total="query_params.tn"
                      :page-size="query_params.sn" :current-page.sync="query_params.cn" @change="change_page"/>
    </div>
  </div>
</template>

<script>

import {mapActions} from 'vuex'
import moment from "moment";

export default {
  name: "alert_index",
  data() {
    return {
      alarm_list: [],
      // 分页数据
      query_params: {
        otherMisId: null,
        otherOrgPath: null,
        dataSource: 'km',
        startDt: null,
        endDt: null,
        queryDt: null,
        fileName: '',
        cn: 1, // 当前页面
        sn: 10, // 每页大小
        tn: 0 // 总条数
      },
      person_groups: [],
      depart_groups: [],
    }
  },
  computed: {},
  mounted() {
    this.query_params.endDt = this.get_default_dt();
    this.build_start_and_query_dt();
  },
  methods: {
    // API方法
    ...mapActions({
      api_list_file: 'api_file_trace_other_file_list',
      query_mis_id_list: 'query_mis_id_list',
      query_org_list: 'query_org_list'
    }),
    get_default_dt() {
      return moment().add(-1, 'days').utcOffset(480).format('YYYY-MM-DD');
    },
    build_start_and_query_dt() {
      let dt_date = moment(this.query_params.endDt);
      this.query_params.queryDt = dt_date.format('YYYYMMDD');
      let days = -1;
      if (this.query_params.dataSource === 'xm') {
        days = -6;
      }
      dt_date.add(days, 'days').utcOffset(480);
      this.query_params.startDt = dt_date.format('YYYY-MM-DD');
    },
    list_user_file() {
      let {otherMisId} = this.query_params;
      if (!otherMisId || otherMisId === '') {
        return this.$mtd.message.warning("请输入用户MisId");
      }
      this.query_params.size = this.query_params.sn;
      this.query_params.page = this.query_params.cn;
      this.api_list_file(this.query_params).then((res) => {
        if (res.code === 0) {
          let {currentPage, limit, total, items} = res.data;
          this.alarm_list = items;
          this.query_params.cn = currentPage;
          this.query_params.sn = limit;
          this.query_params.tn = total;
        } else {
          this.$mtd.message.error('获取数据失败');
        }
      });
    },
    reset_search_form() {
      this.query_params.otherMisId = null;
      this.query_params.otherOrgPath = '';
      this.query_params.dataSource = 'km';
      this.query_params.queryDt = null;
      this.query_params.fileName = [];
      this.query_params.endDt = this.get_default_dt();
      this.build_start_and_query_dt();
      this.list_file_detail();
    },
    change_page(current, size) {
      this.query_params.cn = current;
      this.query_params.sn = size;
      this.list_user_file()
    },
    show_detail(id, filename) {
      this.$router.push({
        name: "file|other_trace|alert_detail",
        params: {
          file_id: id,
          otherMisId: this.query_params.otherMisId,
          filename,
          dataSource: this.query_params.dataSource,
          queryDt: this.query_params.queryDt,
          endDt: this.query_params.endDt
        }
      });
    },
    // 搜索mis
    searchPerson(keyword) {
      if (keyword != null && keyword !== "") {
        this.query_mis_id_list({keyword}).then(res => {
          this.person_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 搜索BU BG
    searchDepart(keyword) {
      if (keyword != null && keyword !== "") {
        keyword = keyword.replace(/\//g, "-");
        this.query_org_list({keyword}).then(res => {
          this.depart_groups = res.data
        }).catch((err) => {
          console.log(err)
        })
      }
    },
  }
}
</script>

<style>

@import "../../../styles/public.css";
@import "../../../styles/reset_table.css";

.policy-search-block .mtd-form-item {
  width: 100%;
}

.policy-search-block {
  background: #F7F7F7;
  padding: 12px 16px;
}

div.disabled-picker-block .mtd-input-disabled {
  opacity: 1;
}

</style>
